<div class="d-flex justify-content-between align-items-center py-1 px-3 paginatorWrapper">
  <ng-template [ngTemplateOutlet]="detailTemplate ?? emptyTemplate" />
  @if (loading || !isNextDisabled) {
    <button
      class="btn btn-primary d-flex justify-content-center align-items-center load-more-btn"
      data-cy="loadMoreBtn"
      data-testid="loadMoreBtn"
      [ngClass]="{ disabled: loading }"
      (click)="next()"
    >
      @if (!loading) {
        <span>Load more</span>
      }
      @if (loading) {
        <div class="spinner-border spinner-border-sm text-white mx-4" data-cy="loadBtn" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      }
    </button>
  }
  @if (!loading && length > 0) {
    <div class="resultsInfo text-end" data-cy="paginator" data-testid="paginator">
      Showing {{ Math.min((pageIndex + 1) * pageSize, length) }} out of {{ length }} items.
    </div>
  }
</div>

<ng-template #emptyTemplate>
  <div></div>
</ng-template>
